import { request } from './http';

export async function getPWSEquipmentServiceLogs(params = {}) {
    const queryParams = new URLSearchParams();
    if (params.filter) {
      queryParams.append('filter', JSON.stringify(params.filter));
    }
    const wantsPage = params.page != null || params.limit != null || params.offset != null;
    if (!wantsPage) {
      queryParams.append('all', '1');
    } else {
      if (params.page) queryParams.append('page', params.page);
      if (params.limit) queryParams.append('limit', params.limit);
      if (params.offset != null) queryParams.append('offset', params.offset);
    }
    if (params.sort) queryParams.append('sort', params.sort);
    if (params.select) queryParams.append('select', params.select);
    return request(`/data/PWSEquipmentServiceLogs?${queryParams.toString()}`);
  }

export async function createPWSEquipmentServiceLog(logData) {
    return request('/data/PWSEquipmentServiceLogs', {
      method: 'POST',
      body: JSON.stringify(logData)
    });
  }

export async function updatePWSEquipmentServiceLog(id, logData) {
    return request(`/data/PWSEquipmentServiceLogs/${id}`, {
      method: 'PUT',
      body: JSON.stringify(logData)
    });
  }

export async function deletePWSEquipmentServiceLog(id) {
    return request(`/data/PWSEquipmentServiceLogs/${id}`, {
      method: 'DELETE'
    });
  }

export const pwsEquipmentServiceLogsApi = {
  getPWSEquipmentServiceLogs,
  createPWSEquipmentServiceLog,
  updatePWSEquipmentServiceLog,
  deletePWSEquipmentServiceLog,
};

